import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import Delta from 'quill-delta';
import { Value } from 'slate';
import BlockTypes, { CONTINUOUS_BLOCK } from '../../types/BlockTypes';
import convertAttributesToMarks from './utils/convertAttributesToMarks';

function shouldMergeWithPreviousNode(node, previousNode) {
  if (!previousNode) return false;
  var parentType = CONTINUOUS_BLOCK[node.type];

  switch (parentType) {
    case BlockTypes.TABLE:
      return parentType === previousNode.type && previousNode.nodes[0].data.tableId === node.data.tableId;

    case BlockTypes.IMAGE_GALLERY:
      return parentType === previousNode.type && previousNode.nodes[0].data.galleryId === node.data.galleryId;

    case BlockTypes.CODES:
      return parentType === previousNode.type && previousNode.nodes[0].data.language === node.data.language;

    case BlockTypes.HINTS:
      return parentType === previousNode.type && previousNode.nodes[0].data.color === node.data.color;

    default:
      return parentType === previousNode.type;
  }
}

function createText(_ref) {
  var text = _ref.insert,
      _ref$attributes = _ref.attributes,
      attributes = _ref$attributes === void 0 ? {} : _ref$attributes;
  return {
    object: 'text',
    text: text,
    marks: convertAttributesToMarks(attributes)
  };
}

function createEntity(_ref2) {
  var insert = _ref2.insert,
      _ref2$attributes = _ref2.attributes,
      attributes = _ref2$attributes === void 0 ? {} : _ref2$attributes;

  var entity = attributes.entity,
      inlineAttributes = _objectWithoutProperties(attributes, ["entity"]);

  return {
    object: 'inline',
    type: entity.type,
    data: entity.data,
    nodes: [createText({
      insert: insert,
      attributes: inlineAttributes
    })]
  };
}

var isEntity = function isEntity(node) {
  return !!node.attributes && !!node.attributes.entity;
};

var EMPTY_TEXT = {
  insert: ''
};
export default function initEditorStateWithDelta(doc) {
  var delta = new Delta(doc);
  var nodes = [];
  delta.eachLine(function (line, _ref3) {
    var type = _ref3.type,
        _ref3$data = _ref3.data,
        data = _ref3$data === void 0 ? {} : _ref3$data;
    var wrapper = CONTINUOUS_BLOCK[type];
    var previousNode = nodes[nodes.length - 1];
    var ops = line.ops.length > 0 ? line.ops : [EMPTY_TEXT];
    var node = {
      object: 'block',
      type: type || BlockTypes.UNSTYLED,
      data: data,
      nodes: ops.map(function (node) {
        return isEntity(node) ? createEntity(node) : createText(node);
      })
    };

    if (wrapper) {
      if (shouldMergeWithPreviousNode(node, previousNode)) {
        previousNode.nodes.push(node);
      } else {
        nodes.push({
          object: 'block',
          type: wrapper,
          nodes: [node]
        });
      }
    } else {
      nodes.push(node);
    }
  });
  return Value.fromJSON({
    document: {
      nodes: nodes
    }
  });
}